<template>
  <div class="app-member-reviews-list">
    <AppReviewableListItem
      v-for="review in reviewsList"
      :key="review.id"
      :review="review"
      class="review-list-item"
      @likes-changed="$emit('likes-changed')"
    />
  </div>
</template>

<script>
import AppReviewableListItem from '@/components/AppReviewableListItem.vue';

export default {
  name: 'AppReviewableList',
  components: { AppReviewableListItem },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getCreatedAtForHuman(date) {
      return date ? this.$moment(date).fromNow() : '';
    },
  },
  computed: {
    reviewsList() {
      return this.reviews.map((review) => ({
        ...review,
        createdAtForHuman: review.createdAt ? this.getCreatedAtForHuman(review.createdAt) : null,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-member-reviews-list {
  display: flex;
  flex-direction: column;

  > .app-member-reviews-list-item:not(:last-child) {
    @media (max-width: vars.$tablet-break-point) {
      border-bottom: 1px solid vars.$c-gray-d8;
      margin-bottom: 15px;
      padding-bottom: 15px;
    }
  }
}

.review-list-item {
  &:not(:last-child) {
    padding-bottom: 36px;
    margin-bottom: 36px;
    border-bottom: 1px solid vars.$c-gray-d8;
  }
}
</style>
